import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Trust as SectionKey } from 'Consts/Questionnaire';
import CircleWithCount from 'Icons/CircleWithCount';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import DateInput from '../Fields/DateInput';
import RadioInput from '../Fields/RadioInput';
import BoolInput from '../Fields/BoolInput';

class TrustForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    this.setState({ title: val });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New trust'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <RadioInput
          label="Trust type"
          name={`trustType.${id}`}
          answerKey="trustType"
          options={[
            { id: 'revocable', text: 'Revocable' },
            { id: 'irrevocable', text: 'Irrevocable' },
          ]}
        />
        <TextInput
          name={`trustGrantor.${id}`}
          answerKey="trustGrantor"
          placeholder="Grantor"
          onChange={this.handleTitleChange}
        />
        <DateInput
          name={`trustDateExecuted.${id}`}
          answerKey="trustDateExecuted"
          placeholder="Date executed"
        />
        <TextInput
          name={`trustTrustee.${id}`}
          answerKey="trustTrustee"
          placeholder="Trustee"
        />
        <TextInput
          name={`trustBeneficiary.${id}`}
          answerKey="trustBeneficiary"
          placeholder="Beneficiary"
        />
        <BoolInput
          label="Funded?"
          name={`trustIsFunded.${id}`}
          answerKey="trustIsFunded"
          checkedChildren={
            <TextInput
              name={`trustFundedDetails.${id}`}
              answerKey="trustFundedDetails"
              placeholder="Details"
            />
          }
        />
      </LabeledVerticalExpander>
    );
  }
}

TrustForm.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  expanded: PropTypes.bool,
};

TrustForm.defaultProps = {
  expanded: false,
};

const TrustSection = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      title="Trust"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Trusts"
        addLabel="Add a trust"
        keyPrefix="trust"
        Of={TrustForm}
      />
    </Section>
  );
};

export default TrustSection;
